import React from 'react';
import { useTranslation } from 'react-i18next';
import { Row, RadioChangeEvent } from 'antd';

import Tabs from 'components/tabs';
import { OUTPATIENT_TYPES } from 'pages/benefits/types/benefitTypes';

import { ImportantNotesButton } from './ImportantNotesButton';

interface OutpatientHeaderProp {
  selectedOutpatientTab: OUTPATIENT_TYPES;
  handleOutpatientTabChange: (e: RadioChangeEvent) => void;
}

function OutpatientHeader({ selectedOutpatientTab, handleOutpatientTabChange }: OutpatientHeaderProp) {
  const { t } = useTranslation();
  const OUTPATIENT_OPTIONS = [
    { id: OUTPATIENT_TYPES.COVERAGE, label: t('benefits.coverage') },
    { id: OUTPATIENT_TYPES.USAGE, label: t('benefits.usage') },
  ];
  return (
    <Row justify="space-between">
      <Tabs
        options={OUTPATIENT_OPTIONS}
        selectedOption={selectedOutpatientTab}
        handleChange={(e) => handleOutpatientTabChange(e)}
      />
      <ImportantNotesButton />
    </Row>
  );
}

export default OutpatientHeader;
